import i18next from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import propertiesParser from 'properties-parser';
import LanguageDetector from 'i18next-browser-languagedetector';
import ViewerSocialProfile from 'models/user/ViewerSocialProfile';
import ViewerUserPreferences from 'models/user/ViewerUserPreferences';
import { restrictedPropertyFiles } from 'utils/WindowPreferencesMappings';

const getLanguageResourceLoadPath = function(lng, ns, userRoles, windowPreferences) {
    const restrictedRoleKey = restrictedPropertyFiles['/' + ns + '/' + ns];

    if (restrictedRoleKey) {
        const userRolesToRestrictTo = windowPreferences[restrictedRoleKey].split(',');
        if (
            !userRolesToRestrictTo ||
            !userRoles ||
            userRolesToRestrictTo.every((role) => userRoles.indexOf(role.trim()) < 0)
        ) {
            // call '/common/common.properties' instead of the restricted properties file
            ns = 'common';
        }
    }

    const resourceLanguage = lng[0].replace('-', '_');
    let resourceLoadPath = '/web-translations/' + ns + '/' + ns;

    if (resourceLanguage === 'en') {
        resourceLoadPath = resourceLoadPath + '.properties';
    } else {
        resourceLoadPath = resourceLoadPath + '_' + resourceLanguage + '.properties';
    }

    return resourceLoadPath;
};

const parsePropertyFile = function(resource) {
    return propertiesParser.parse(resource);
};

const userRoles = ViewerSocialProfile.get('userRoles');
const windowPreferences = window.PREFERENCES || {};

const userLocale = ViewerUserPreferences.getLocale();
const URL_BUST_VALUE = window.URL_BUST_VALUE;
const language = ViewerSocialProfile.get('displayName') ? userLocale : ''; // Set it to '' so that it picks up the languages stored in GarminUserPrefs
const toCache = language ? '' : 'cookie'; // Do not overrite GarminUserPrefs if language is defined e.g. 'en,es,pt' since we only want 'en-US' formats.
const supportedLngs = [
    'ar',
    'bg',
    'cs',
    'da',
    'de',
    'en',
    'es',
    'et',
    'fr',
    'hr',
    'it',
    'iw',
    'lv',
    'lt',
    'hu',
    'nl',
    'no',
    'pl',
    'pt_BR',
    'pt',
    'ru',
    'ro',
    'sk',
    'sl',
    'fi',
    'sv',
    'vi',
    'tr',
    'el',
    'ja',
    'ko',
    'th',
    'in',
    'ms',
    'zh_TW',
    'zh_CN',
    'uk'
];

i18next
    .use(HttpApi)
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        lng: language,
        supportedLngs,
        ns: ['common'],
        defaultNS: 'common',
        fallbackLng: 'en',
        keySeparator: false,
        interpolation: {
            prefix: '{', //default prefix is '{{' but we use single brackets
            suffix: '}' //default suffix is '}}' but we use single brackets
        },
        missingInterpolationHandler: ({ match }) => {
            return match;
        },
        backend: {
            loadPath: (lng, ns) => getLanguageResourceLoadPath(lng, ns, userRoles, windowPreferences),
            parse: parsePropertyFile,
            queryStringParams: { bust: URL_BUST_VALUE } //bust param here
        },
        react: {
            useSuspense: false,
            wait: true // only display text if properties files are loaded
        },
        detection: {
            caches: [toCache],
            lookupCookie: 'GarminUserPrefs',
            convertDetectedLanguage: (lng) => lng.replace('-', '_')
        },
        initImmediate: false
    });

export default i18next;
